<template>
    <div v-if="getSearchResultsField('isSearchResultActive')" id="contentPane"
         :class="getLoadingStatus ? 'searchResultsPane skeleton-loader' : 'searchResultsPane '"
         style="visibility: visible;">
        <template v-if="getSearchResultsField('nohits')">
            <div class="no-results-pane">
                <div class="no-result-msg">{{ getNoResultMsg }}</div>
                <div class="search-tips">
                    <label>{{$t('search_tips')}}</label>
                    <ul class="search-tips-points">
                        <li v-for="tip in getSearchTips" :key="tip">
                            {{ $t(tip) }}
                        </li>
                    </ul>
                </div>
            </div>
        </template>
        <template v-else>
            <Standards v-if="isActiveSearchTab('search.standards')"/>
            <Collections v-if="isActiveSearchTab('search.assets')"/>
        </template>
    </div>
</template>

<script>
import Standards from './Standards';
import Collections from './Collections';
import {createNamespacedHelpers} from 'vuex';
import i18n from "@/plugins/i18n";

const {mapGetters, mapActions} = createNamespacedHelpers('searchresults');
const search_results_data = window.search_results_data || '';
const search_results_active_tab = window.search_results_active_tab || '';

export default {
    name: 'SearchResults',
    components: {
        Standards,
        Collections
    },
    computed: {
        ...mapGetters([
            'getLoadingStatus',
            'getSearchResultsField',
            'isActiveSearchTab'
        ]),
        getSearchTips() {
            const arrStandardSearchTips = [
                'no_result_standard_search_tip1',
                'no_result_standard_search_tip2',
                'no_result_standard_search_tip3',
                'no_result_standard_search_tip4',
                'no_result_standard_search_tip5',
                'no_result_standard_search_tip6',
                'no_result_standard_search_tip7'
            ];
            const arrCollectionSearchTips= [
                'no_result_collection_search_tip1',
                'no_result_collection_search_tip2',
                'no_result_collection_search_tip3',
                'no_result_collection_search_tip4',
                'no_result_collection_search_tip5',
                'no_result_collection_search_tip6'
            ];
            const searchTab = this.getSearchResultsField('searchTab');
            if(searchTab == 'search.standards') {
                return arrStandardSearchTips;
            }   
            else if(searchTab == 'search.assets') {
                return arrCollectionSearchTips;
            }
            else {
                return [];
            }
               
        },
        getNoResultMsg() {
            const searchTerms = this.getSearchResultsField('searchTerms');
            const resultNotFoundMessage = searchTerms ? i18n.t('no_result_found_for') + ' "' + searchTerms + '".' : i18n.t('no_result_found');
            return resultNotFoundMessage;
        }
    },
    mounted() {
        if (typeof (search_results_data) != "undefined" && search_results_data !== '') {
            //console.log('search_results_data', search_results_data);
            this.setSearchResults(JSON.parse(Buffer.from(search_results_data, "base64")));
        }

        if (typeof (search_results_active_tab) != "undefined" && search_results_active_tab !== '') {
            //console.log('search_results_active_tab', search_results_active_tab);
            this.setActiveSearchTab(JSON.parse(Buffer.from(search_results_active_tab, "base64")));
        }
    },
    methods: {
        ...mapActions([
            'setSearchResults',
            'setActiveSearchTab',
        ])
    }
}
</script>

<style lang="scss">
@import "SearchResults";
</style>